import { createSlice } from "@reduxjs/toolkit";

import { getMaritalInformationRes } from "core/http/service/personnelInformation/resTypes";

import { set, uniqueId } from "lodash";

interface InitialState {
  currentData: getMaritalInformationRes;
  formData: getMaritalInformationRes;
  changedData: {
    [key: string]: any;
  };
}

const initialState: InitialState = {
  currentData: {
    familyMembers: [],
    maritalStatus: "",
  },
  formData: {
    familyMembers: [],
    maritalStatus: "",
  },
  changedData: undefined,
};

const formEditMaritalInformationSlice = createSlice({
  name: "formEditMaritalInformation",
  initialState,
  reducers: {
    updateFormEditMaritalInformation: (state, action) => {
      const keys = Object.keys(action.payload);
      for (let i = 0; i < keys.length; i++) {
        set(state.formData, keys[i], action.payload[keys[i]]);
      }
    },
    updateMaritalInformationCurrentData: (state, action) => {
      state.currentData = action.payload;
    },
    addMoreFamilyMembers: (state) => {
      state.formData.familyMembers = [
        ...(state.formData.familyMembers ?? []),
        {
          uuid: uniqueId(),
          bornDate: "",
          fullName: "",
          gender: "",
          relativeTypeName: "",
        },
      ];
    },
    removeFamilyMembers: (state) => {
      state.formData.familyMembers = state.formData.familyMembers.slice(0, -1);
    },
    updateMaritalInformationChangedData: (state, action) => {
      state.changedData = action.payload;
    },
    resetFormEditMaritalInformation: () => {
      return { ...initialState };
    },
  },
});

export const {
  updateMaritalInformationCurrentData,
  updateMaritalInformationChangedData,
  updateFormEditMaritalInformation,
  addMoreFamilyMembers,
  resetFormEditMaritalInformation,
  removeFamilyMembers,
} = formEditMaritalInformationSlice.actions;

export default formEditMaritalInformationSlice.reducer;
